import { Injectable } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SpinnerTailService {
  private tailUpdated = new Subject<{
    ready: boolean;
    items: number;
    done: number;
  }>();

  private tailItems = 0;
  private tailDone = 0;

  public tail() {
    return this.tailUpdated.asObservable();
  }

  constructor(private spinner: NgxSpinnerService) {}

  public show() {
    this.tailItems++;
    this.spinner.show();
  }

  public hide() {
    this.tailDone++;
    if (this.tailDone >= this.tailItems) {
      this.tailUpdated.next({
        done: this.tailDone,
        items: this.tailItems,
        ready: this.tailDone == this.tailItems,
      });
      this.tailItems = 0;
      this.tailDone = 0;
      this.spinner.hide();
    }
  }
}
